var api = require("!../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../css-loader/dist/cjs.js??ref--12-1!../postcss-loader/src/index.js??embedded!./toastr.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;